/**
 * CMSD dynamic header name.
 *
 * @public
 */
export const CMSD_DYNAMIC = 'CMSD-Dynamic'
